import React from 'react'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { useDispatch } from 'react-redux'

import { SearchInput } from './SearchInput'
import { resetPage, setSearchString } from 'redux/slices/TextAnalysis'
import { fetchContributions } from 'redux/thunks/TextAnalysis'
import { parseSearch } from './ParseSearch'
import Export from './Export'

const TagSearchAnalyzer = () => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
  const dispatch = useDispatch()

  const onSearch = (value: string) => {
    dispatch(resetPage())
    dispatch(setSearchString(parseSearch(value)))
    dispatch(fetchContributions())
  }

  return (
    <Grid
      item
      xs={12}
      my={2}
      data-testid="ta-tag-search-analyser"
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: isSmallScreen ? 'transparent' : 'white',
        borderRadius: '0.25rem',
        height: '3.375rem',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: isSmallScreen ? '100%' : 'auto',
          ml: isSmallScreen ? 0 : 'auto',
          gap: 2,
        }}
      >
        <SearchInput onSearch={onSearch} />
        <Export hide={isSmallScreen} />
      </Box>
    </Grid>
  )
}

export default React.memo(TagSearchAnalyzer)
